import { useLocation } from 'react-router';

export const useCatalogueRoutePrefix = () => {
  const location = useLocation();

  const splitter = location.pathname.includes('/poCatalogue') ? '/poCatalogue' : '/catalogue';

  const [prefix] = location.pathname.split(splitter);

  return prefix;
};
